const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
  props: ['type'],
  data() {
    return {
      login: '',
      password: '',
      platform: 'web',
      deviceUUID: '',
      hidePw: true,
      requestType: '',
    };
  },
  methods: {
    Login() {
      const app = this;
      const deviceUUID = this.$cookies.get('mindboxDeviceUUID') || null;
      app.$store.getters.axl.post('profiles/api/v3/login', {
        login: app.login,
        platform: 'web',
        deviceUUID,
        password: app.password,
        type: app.isDealer ? 'phone' : 'email',
      })
        .then((response) => {
          app.$store.dispatch('UserLogin', response.data);
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
  },
  computed: {
    loading() { return this.$store.state.loading; },
    isManager() { return this.$props.type === 'manager'; },
    isDealer() { return this.$props.type === 'dealer'; },
    redRoute() { return (this.$props.type) ? `/register/${this.$props.type}` : '/'; },
    loginRules() {
      return this.isManager
        ? [v => pattern.test(v) || 'Поле E-mail заполнено с ошибками']
        : [v => (v && v.length > 14) || 'Номер телефона не заполнен'];
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
  },
};
